import titleAndDescription from './TitleAndDescription';
import callouts from './Callouts';
import detailCharts from './DetailCharts';
import comments from './Comments';

export default [titleAndDescription, callouts, detailCharts, comments];
